var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1936 12.9738C16.6536 9.98376 16.4936 5.56376 13.7036 2.76375C10.7336 -0.206245 5.92357 -0.206245 2.95357 2.76375C-0.0164258 5.73376 -0.0164258 10.5438 2.95357 13.5138C5.61357 16.1738 9.76357 16.4538 12.7336 14.3338L17.8636 19.4638L19.2736 18.0538L14.1936 12.9738ZM12.2836 12.1038C10.0936 14.2938 6.55357 14.2938 4.36357 12.1038C2.17357 9.91376 2.17357 6.37375 4.36357 4.18375C6.55357 1.99375 10.0936 1.99375 12.2836 4.18375C14.4736 6.37375 14.4736 9.91376 12.2836 12.1038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/discoverIcon.eaf6606fd23308d1aee08b9f83a6d36e.svg";
export { ForwardRef as ReactComponent };